/**
 * @private
 * @interface IQueryHelper
 *
 * @description
 * Query helper interface
 *
 * @author Olivier Margarit
 *
 * @since 0.2
 */
export interface IQueryHelper {
    /**
     * @property {string} alias the query alias
     */
    alias: string;
}
